type FastApiErrorDetail = { msg: string; loc?: unknown[]; type?: string; input?: unknown; ctx?: unknown } | string;

export function parseDetail(detail: FastApiErrorDetail | FastApiErrorDetail[] | unknown, fallback: string): string {
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => (typeof d === "string" ? d : (d as { msg?: string }).msg ?? fallback))
      .filter(Boolean)
      .join("; ");
  }
  if (typeof detail === "object" && detail !== null && "msg" in (detail as object)) {
    return (detail as { msg: string }).msg;
  }
  return fallback;
}
